import { fetchWithAuth } from '../auth/authService';

export const getHomepageService = async (platform = 'web') => {
  const response = await fetchWithAuth(`/api/public/GetHomepage?platform=${encodeURIComponent(platform)}`, {
    method: 'GET',
  });

  return response; // fetchWithAuth already handles response normalization to .data
};

export const bookDemoService = async (data) => {
  const response = await fetchWithAuth(`/api/public/book-demo`, {
    method: 'POST',
    body: JSON.stringify(data),
  });

  return response;
};
